import React from 'react';
import Box from '../Box/Box';

type TImageNumber = {
  number: string | number;
  className?: string;
};

const ImageNumber = ({ number, className = '' }: TImageNumber) => {
  return (
    <Box name="Image-number" as="div" className={`hz-Image-number ${className}`}>
      {number}
    </Box>
  );
};

export default ImageNumber;
